import { Integer } from '@type-r/ext-types';
import { AttributesMixin, define, Model, type } from '@type-r/models';
import { fetchJson, restfulIO } from './endpoint';

@define
export class PartModel extends Model {
    static attributes = {
        partNumber: type( String ).required,
        childPosition: Integer,
        quantity: type( Integer ).check(v => v !== null && v !== undefined),
        price: Number,
        assignedIdentification: Integer,
        line: Integer,
        part_error_message: ''
    }

    get extended_price(){
      return this.price * this.quantity;
    }

    static collection = {
        comparator : x => x.assigned_identification
    }
}

export interface PartModel extends AttributesMixin<typeof PartModel>{}

const EmailString = ( error ) => type(String).check(x => {
    if (x && x.length > 0) {
        var re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(x);
    }
    return true;
  }, error);

export interface EmailAddressModel extends AttributesMixin<typeof EmailAddressModel> {}
@define
export class EmailAddressModel extends Model {
    static attributes = {
        email: EmailString('Email address is not valid')
    }
}


export interface CarrierType extends AttributesMixin<typeof CarrierType>{};
@define
export class CarrierType extends Model {
    static attributes = {
        code: String,
        method : String
    }

    static async getAll() {
        return await fetchJson("GET", `/api/v2/invoices/carriertypes`);
    }
}

export interface InternalInvoiceStatus extends AttributesMixin<typeof InternalInvoiceStatus>{};
@define
export class InternalInvoiceStatus  extends Model  {
    static endpoint = restfulIO('/api/v2/invoice-management/internal-invoice-status');
    static attributes = {
        internalStatus : String,
        statusDescription : String,
        companyId: Number,
        invoiceId: String,
        isActive: Boolean
    };
}
